<template>
  <form class="file-form">
    <label class="input">
      <span class="input__name">{{ label }}</span>
      <div class="input__file_wrapper">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 3L12 15M12 15L6 9M12 15L18 9"
            stroke="#303333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <line
            x1="5"
            y1="21"
            x2="19"
            y2="21"
            stroke="#303333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Максимальный размер файла 2 МБ (JPEG/PNG)</span>
        <input
          class="input__file"
          name="file"
          type="file"
          @change="processFile"
          accept="image/jpeg,image/png"
        />
      </div>
    </label>
    <div class="error-tooltip">
      Ошибка. Размер изображения слишком большой.
    </div>
    <div class="input__current_file">
      <img
        src="../../assets/img/img-file-icon.png"
        alt="img"
        width="48"
        height="48"
      />
      <div class="input__current_text">
        <p class="input__current_header"></p>
        <p class="input__current_size"></p>
        <button class="input__current_delete" @click="deleteFile" type="reset">
          Удалить изображение
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "CInputFile",
  props: ["type", "label"],
  methods: {
    processFile(e) {
      let file = e.target.files[0];
      if (file) {
        if (file.size < 2000000) {
          this.$emit("input", file);
          this.$emit("valid");
          document.querySelector(".input__current_file").style =
            "display: flex;";
          document.querySelector(".input__current_header").innerHTML =
            file.name;
          document.querySelector(".input__current_size").innerHTML =
            (file.size / 1000000).toFixed(2) + " МБ";
          document
            .querySelector(".input__file_wrapper")
            .classList.add("input__file_wrapper--disabled");
          document.querySelector(".input__file").setAttribute("disabled", "");
        } else {
          this.$emit("invalid");
          let tooltip = document.querySelector(".error-tooltip");
          tooltip.classList.add("error-tooltip--active");
          setTimeout(() => {
            tooltip.classList.remove("error-tooltip--active");
            document.querySelector(".file-form").reset();
          }, 4000);
        }
      } else {
        this.$emit("invalid");
      }
    },
    deleteFile() {
      this.$emit("input", null);
      this.$emit("invalid");
      document.querySelector(".input__current_file").style = "display: none;";
      document.querySelector(".input__current_header").innerHTML = "";
      document.querySelector(".input__current_size").innerHTML = "";
      document.querySelector(".input__file").removeAttribute("disabled");
      document
        .querySelector(".input__file_wrapper")
        .classList.remove("input__file_wrapper--disabled");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.file-form {
  position: relative;
}
.input {
  position: relative;
  display: flex;
  flex-direction: column;

  input {
    border: 1px solid #cccccc;
    outline: none;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 16px;
    background: transparent;
    resize: none;

    &:focus {
      border-color: #3479cc;
    }
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  &__file_wrapper {
    background: #ffffff;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;

    transition: background 0.3s ease-in-out;

    &:hover {
      background: #3d64e9;

      span {
        color: #fff;
      }

      svg path,
      svg line {
        stroke: #fff;
      }
    }
    @media #{$mobile} {
      background: #f2f2f2;
    }

    & *:first-child {
      margin-right: 20px;
    }

    span {
      font-size: 15px;
      max-width: 180px;
    }

    input {
      display: none;
    }

    &--disabled {
      background: #ffffff;

      span {
        color: #ccc;
      }

      svg path,
      svg line {
        stroke: #ccc;
      }

      &:hover {
        background: #ffffff;

        span {
          color: #ccc;
        }

        svg path,
        svg line {
          stroke: #ccc;
        }
      }
    }
  }

  &__current_file {
    display: none;
    margin-top: 20px;

    img {
      margin-right: 10px;
    }
  }

  &__current_header {
    width: 230px;
    margin: 0 0 2px 0;
    overflow: hidden;

    font-size: 12px;
    line-height: 14px;
    color: #303333;
  }

  &__current_size {
    margin: 0 0 2px 0;

    font-size: 10px;
    line-height: 12px;
    color: #666666;
  }

  &__current_delete {
    margin: 0;
    padding: 0;

    border: none;
    background-color: transparent;

    font-size: 12px;
    line-height: 14px;
    color: #cc324a;

    cursor: pointer;

    &::before {
      content: url("../../assets/img/trash-icon.svg");

      width: 11px;
      height: 12px;
      margin-right: 6px;
    }
  }
}

.error-tooltip {
  background-color: #cc324a;
  padding: 15px;
  border-radius: 5px;
  color: #ffffff;
  position: absolute;
  width: 258px;
  z-index: 9;
  display: none;
  top: 50%;
  transform: translate(100%, -50%);
  right: -9px;

  font-size: 15px;
  line-height: 18px;

  @media #{$tablet} {
    top: -8px;
    transform: translate(-50%, -100%);
    left: 50%;
  }

  &--active {
    display: block;

    animation: showTooltip 4s ease-in-out;
  }

  @keyframes showTooltip {
    0% {
      opacity: 0;
    }

    25% {
      opacity: 1;
    }

    75% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  &::after {
    content: " ";
    position: absolute;
    margin-top: -8px;
    border-width: 8px;
    border-style: solid;
    z-index: 10;
    top: 50%;
    right: 100%; /* To the left of the tooltip */
    border-color: transparent #cc324a transparent transparent;

    @media #{$tablet} {
      top: 100%;
      left: calc(50% - 9px);
      border-color: #cc324a transparent transparent transparent;
      margin-top: 0;
    }
  }
}
</style>
